<template>
   <ObiModal as="form" ref="modal" @submit.prevent="submitForm">
      <template #header>
         <ObiTitle :icon="IconLayers" icon-stacked :title="$t('title')" :subtitle="$t('subtitle')" />
      </template>
      <ObiRow>
         <ObiCol sm="6">
            <ObiFloatingInput
               compact
               :label="$t('fields.first_name')"
               :disabled="isLoading"
               :placeholder="$t('fields.first_name')"
               v-model="formDataUser.first_name"
               :errors="formDataUser.errors.get('first_name')"
            />
         </ObiCol>
         <ObiCol sm="6">
            <ObiFloatingInput
               compact
               :label="$t('fields.last_name')"
               :disabled="isLoading"
               :placeholder="$t('fields.last_name')"
               v-model="formDataUser.last_name"
               :errors="formDataUser.errors.get('last_name')"
            />
         </ObiCol>
      </ObiRow>

      <ObiRow class="mt-2">
         <ObiCol sm="12">
            <ObiFloatingInput
               compact
               :label="$t('fields.email')"
               :disabled="isLoading"
               :placeholder="$t('fields.email')"
               v-model="formDataUser.email"
               :errors="formDataUser.errors.get('email')"
            />
         </ObiCol>
      </ObiRow>

      <ObiRow class="mt-2">
         <ObiCol sm="12">
            <ObiFloatingInput
               compact
               type="password"
               :label="$t('fields.password')"
               :disabled="isLoading"
               :placeholder="$t('fields.password')"
               v-model="formDataUser.password"
               :errors="formDataUser.errors.get('password')"
            />
         </ObiCol>
      </ObiRow>

      <template slot="actions">
         <ObiButton
            wider
            icon-right
            type="submit"
            :loading="isLoading"
            :text="$t('actions.save')"
            icon="mdi mdi-arrow-right"
         />
      </template>
   </ObiModal>
</template>

<script>
import ErrorHandler from '@/libs/error-handler';
import PanelTenantApi from '@/api/TenantApi';

import IconLayers from '@/components/Icons/general/IconLayers.svg';

import formDataUser from '@/views/pages/Settings/FormData/form-data-user';

export default {
   name: 'ModalLocationCreate',
   i18n: {
      messages: {
         tr: {
            title: 'Yönetici Ekleyin',
            subtitle: 'Bilgileri girerek yeni yönetici ekleyebilirsiniz',
            form_title: 'Kullanıcı Bilgilerini Giriniz',
            fields: {
               first_name: 'Ad',
               last_name: 'Soyad',
               email: 'E-Posta Adresi',
               password: 'Şifre',
            },
            actions: {
               save: 'Kaydet',
            },
         },
         en: {
            title: 'Add Administrator',
            subtitle: 'You can add a new administrator by entering the details',
            form_title: 'Enter User Information',
            fields: {
               first_name: 'First Name',
               last_name: 'Last Name',
               email: 'Email Address',
               password: 'Password',
            },
            actions: {
               save: 'Save',
            },
         },
      },
   },
   data() {
      return {
         IconLayers,
         isLoading: false,
         formDataUser,
      };
   },
   methods: {
      show() {
         this.$refs.modal.show();
      },
      hide() {
         this.$refs.modal.hide();
      },
      async submitForm() {
         if (!this.formDataUser.isValid({ disableDirtyCheck: true })) return;

         this.isLoading = true;

         try {
            const response = await PanelTenantApi.users.store(this.formDataUser.toObject());

            this.formDataUser.reset();

            this.hide();
            this.$emit('success', response);
         } catch (err) {
            ErrorHandler.handle(err);

            this.$emit('failed', err);
         } finally {
            this.isLoading = false;

            this.$emit('end');
         }
      },
   },
};
</script>
